{
  "nav": {
    "dashboard": "Dashboard",
    "teacherDashboard": "Meine Sitzungen",
    "projects": "Projekte",
    "fairQuote": "Fair Quote",
    "exitFairQuote": "Fair Quote verlassen",
    "contacts": "Kontakte",
    "entities": "Entitäten",
    "products": "Produkte",
    "colors": "Farben",
    "courses": "Kurse",
    "teachers": "Lehrkräfte",
    "students": "Lernende",
    "certifications": "Zertifizierungen",
    "staff": "Personal",
    "company": "Mein Unternehmen",
    "overview": "Überblick",
    "sections": {
      "projects": "Projekte",
      "shop": "Shop & Katalog",
      "entity": "Entitäts-Bereich",
      "learning": "Schulung",
      "admin": "Administration"
    },
    "enrollments": "Anmeldungen",
    "calendar": "Kalender",
    "userManagement": "Benutzer",
    "applicatorProfiles": "Applikateur-Profile",
    "certificationDefinitions": "Zertifikatsdefinitionen",
    "switchEntity": "Entität wechseln"
  }
}
